import React from "react";
import { Row, Col, Table, Descriptions, Modal, Spin } from "antd";
import { constructDisplayPrice } from "utils/general";
import moment from "moment";
import { DeleteOutlined } from "@ant-design/icons";
import { deleteLead } from "apis/lead";
import { useFetchConstant } from "apis/constant";
import { isArray } from "util";
import { LinkOutlined } from "@ant-design/icons";
import Locale from "react-intl-universal";

import "./expandableRow.css";
const ExpandableRow = (props) => {
  const {
    isLoading: isPropertyPurchaseLoading,
    data: propertyPurchasePurpose,
  } = useFetchConstant("propertyPurchasePurpose");

  const handleDeleteLeads = async () => {
    deleteLead(props.data._id)
      .then((res) => {
        console.log(res);
      })
      .then((err) => {
        console.log(err);
      });
  };
  const columns = [
    {
      title: Locale.get("leadDashboard.expandableRow.purpose"),
      dataIndex: "purchase_purpose",
      key: "purchase_purpose",
      render: (value) => {
        if (
          isArray(propertyPurchasePurpose) &&
          propertyPurchasePurpose.length > 0
        ) {
          const buffer = [...propertyPurchasePurpose];
          const lookup = buffer.filter((x) => x.code === value);
          if (lookup.length > 0) {
            return lookup[0].label;
          } else {
            return value;
          }
        } else {
          return value;
        }
      },
    },
    {
      title: Locale.get("leadDashboard.expandableRow.loanAmount"),
      dataIndex: "mortgage_loan_amount",
      key: "mortgage_loan_amount",
      render: (value) => (value ? constructDisplayPrice(value) : "-"),
    },
    {
      title: Locale.get("leadDashboard.expandableRow.monthlyInstallment"),
      dataIndex: "mortgage_monthly_installment",
      key: "mortgage_monthly_installment",
      render: (value) => (value ? constructDisplayPrice(value) : "-"),
    },
    {
      title: Locale.get("leadDashboard.expandableRow.mrta"),
      dataIndex: "is_insured",
      key: "is_insured",
    },
  ];

  return (
    <Spin spinning={isPropertyPurchaseLoading}>
      <Row
        style={{
          border: "1px solid #e0e0e0",
          padding: 16,
          borderRadius: 8,
          backgroundColor: "#fff",
        }}
      >
        <Col span={24} style={{ marginBottom: 32 }}>
          <Descriptions
            layout="vertical"
            size="small"
            column={{ xs: 1, md: 2, lg: 3 }}
            // column={3}
            bordered
            title={
              <span style={{ fontSize: 16, color: "#000", fontWeight: 600 }}>
                {Locale.get("leadDashboard.expandableRow.userInfo")}
              </span>
            }
            extra={
              <span
                style={{ fontSize: 16, color: "red", cursor: "pointer" }}
                onClick={() =>
                  Modal.confirm({
                    title: `${Locale.get(
                      "leadDashboard.expandableRow.confirmDelete"
                    )} ${props.data.name}`,
                    onOk: handleDeleteLeads,
                    okText: (
                      <span>
                        <DeleteOutlined />{" "}
                        {Locale.get("leadDashboard.expandableRow.delete")}
                      </span>
                    ),
                    okType: "danger",
                  })
                }
              >
                <DeleteOutlined />{" "}
                {Locale.get("leadDashboard.expandableRow.delete")}
              </span>
            }
            style={{ width: "100%" }}
          >
            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {Locale.get("leadDashboard.expandableRow.name")}
                </span>
              }
            >
              {props.data.name}
            </Descriptions.Item>
            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {Locale.get("leadDashboard.expandableRow.gender")}
                </span>
              }
            >
              {props.data.gender}
            </Descriptions.Item>
            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {Locale.get("leadDashboard.expandableRow.age")}
                </span>
              }
            >
              {props.data.dob
                ? moment()
                    .diff(moment(props.data.dob, "YYYY-MM-DD"), "year")
                    .toString()
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {Locale.get("leadDashboard.expandableRow.dob")}
                </span>
              }
            >
              {props.data.dob}
            </Descriptions.Item>
            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {Locale.get("leadDashboard.expandableRow.idPassportNo")}
                </span>
              }
            >
              {props.data.nric ? props.data.nric : "-"}
            </Descriptions.Item>

            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {Locale.get("leadDashboard.expandableRow.contact")}
                </span>
              }
            >
              {props.data.contact}
            </Descriptions.Item>

            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {Locale.get("leadDashboard.expandableRow.email")}
                </span>
              }
            >
              {props.data.email}
            </Descriptions.Item>

            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {Locale.get("leadDashboard.expandableRow.occupation")}
                </span>
              }
            >
              {props.data.occupation}
            </Descriptions.Item>

            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {Locale.get("leadDashboard.expandableRow.maritalStatus")}
                </span>
              }
            >
              {props.data.marital_status}
            </Descriptions.Item>
          </Descriptions>
        </Col>
        <Col span={24} style={{ marginBottom: 8 }}>
          <span style={{ fontSize: 16, color: "#000", fontWeight: 600 }}>
            {Locale.get("leadDashboard.expandableRow.mortgageLoan")}
          </span>
        </Col>
        <Col span={24} style={{ marginBottom: 32 }}>
          <Table
            bordered
            size="small"
            rowKey="_id"
            dataSource={props.data.property}
            columns={columns}
            pagination={false}
          />
        </Col>
        <Col span={24} style={{ marginBottom: 32 }}>
          <Descriptions
            size="small"
            layout="vertical"
            column={{ xs: 1, md: 3 }}
            bordered
            title={
              <span style={{ fontSize: 16, color: "#000", fontWeight: 600 }}>
                {Locale.get("leadDashboard.expandableRow.familyChildren")}
              </span>
            }
            style={{ width: "100% !important", borderColor: "#000" }}
          >
            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {" "}
                  {Locale.get("leadDashboard.expandableRow.monthlyExpense")}
                </span>
              }
            >
              {props.data.personal_expenses
                ? constructDisplayPrice(props.data.personal_expenses)
                : "-"}
            </Descriptions.Item>
            {/* <Descriptions.Item
            style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  Monthly Car & Loan Payment
                </span>
              }
            >
              {props.data.personal_expenses
                ? constructDisplayPrice(props.data.personal_expenses)
                : "-"}
            </Descriptions.Item> */}
            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {" "}
                  {Locale.get("leadDashboard.expandableRow.existingInsurance")}
                </span>
              }
            >
              {props.data.insurance_policy}
            </Descriptions.Item>
            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {" "}
                  {Locale.get(
                    "leadDashboard.expandableRow.insuranceAttachment"
                  )}
                </span>
              }
            >
              {props.data.insurance_attachment &&
              props.data.insurance_attachment.length > 0
                ? props.data.insurance_attachment.map((x) => (
                    <Row>
                      <a
                        key={x.url}
                        href={x.url}
                        target="_blank"
                        style={{
                          color: "#0000cd",
                          textDecoration: "underline",
                        }}
                      >
                        <LinkOutlined /> {x.name}
                      </a>
                    </Row>
                  ))
                : "-"}
            </Descriptions.Item>

            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {" "}
                  {Locale.get("leadDashboard.expandableRow.haveChildren")}
                </span>
              }
            >
              {props.data.have_children}
            </Descriptions.Item>

            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {Locale.get("leadDashboard.expandableRow.noOfChildren")}
                </span>
              }
            >
              {props.data.no_of_children ? props.data.no_of_children : "-"} /{" "}
              {props.data.children_age
                ? props.data.children_age + " yrs old"
                : "-"}
            </Descriptions.Item>

            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {Locale.get(
                    "leadDashboard.expandableRow.yearToTakeCareChild"
                  )}
                </span>
              }
            >
              {props.data.children_age_extra
                ? props.data.children_age_extra
                : "-"}
            </Descriptions.Item>

            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {" "}
                  {Locale.get("leadDashboard.expandableRow.familyDependent")}
                </span>
              }
            >
              {props.data.family_member_to_take_care}
            </Descriptions.Item>

            <Descriptions.Item
              style={{ fontSize: 16 }}
              label={
                <span style={{ fontWeight: 600 }}>
                  {Locale.get(
                    "leadDashboard.expandableRow.yearToTakeCareFamilyDependent"
                  )}
                </span>
              }
            >
              {props.data.legafamily_member_to_take_care_extra}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </Spin>
  );
};

export default ExpandableRow;
